// ToastStyles.ts
import styled from "styled-components";

export const ToastContainer = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 54px;
  z-index: 150;
`;

export const ToastMessage = styled.div`
  background-color: var(--ons-color-black);
  color: var(--ons-color-white);
  min-width: 280px;
  padding: 10px 18px;
  text-align: center;
  position: relative;
  line-height: 44px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;

  svg {
    fill: var(--ons-color-white);
    padding: 10px 10px 10px 10px;
    height: 44px;
    width: auto;
    margin: 0px 0px 0px 20px;

    &:hover {
      background-color: var(--ons-color-grey-100);
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;
